import { Provider } from '@angular/core';

import { NotificationRepositoryImpl } from '@app/data/repositories/notification/notification.repository';
import { NOTIFICATION_REPOSITORY } from '@app/domain/repositories/notification.repository.contract';

export const notificationRepositoryProvider: Provider = {
  provide: NOTIFICATION_REPOSITORY,
  useClass: NotificationRepositoryImpl
};
